module.exports = __webpack_public_path__ + "img/center_talk.0fbb43f8.gif";